<script setup lang="ts">
interface Props {
  active?: boolean
  disabled?: boolean
  bigger?: boolean
  noHover?: boolean
  id?: string
}

withDefaults(defineProps<Props>(), {
  active: false,
  disabled: false,
  bigger: false,
  noHover: false,
})
</script>

<template>
  <button class="chip" type="button" :class="{ active, disabled, bigger, noHover }" :id="id">
    <slot />
  </button>
</template>

<style scoped lang="scss">
.chip {
  @include h6-5;
  color: $sub-text;
  background-color: $ui-gray-1;
  cursor: pointer;
  @extend %hover-transition;
  border: 1px solid $ui-gray-1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  padding: 0px 16px;
  border-radius: 30px;
  white-space: nowrap;

  position: relative;
  &:before {
    content: '';
    position: absolute;
    top: -10px;
    right: -8px;
    bottom: -10px;
    left: -8px;
  }

  &.active {
    border-color: $sub-green;
    color: #008443;
    background-color: $sub-green;
  }

  &.bigger {
    @include h5-4;
    color: $primary-text;
    padding: 0px 8px;
    height: 26px;

    @media (hover: hover) {
      &:hover {
        border-color: $primary-green;
        color: $white;
        background-color: $primary-green;
      }
    }
  }

  &.active.bigger {
    border-color: $primary-green;
    color: $white;
    background-color: $primary-green;
  }

  &.noHover {
    @media (hover: hover) {
      &:hover {
        border-color: $sub-green;
        color: $primary-green;
        background-color: $sub-green;
      }
    }
  }

  @media (hover: hover) {
    &:hover {
      border-color: $sub-green;
      color: $primary-green;
      background-color: $sub-green;
    }
  }

  &.disabled {
    pointer-events: none;
    border-color: $ui-gray-3;
    color: $ui-gray-3;
    background-color: $white;
  }

  &.disabled.bigger {
    border-color: $sub-text;
    color: $sub-text;
  }
}
</style>
